module.exports = __webpack_public_path__ + "img/object_background.c8cda398.png";